import { SeverityKey } from '../../types'
import { createSnackbar } from './actions'

export const snack = (message: string, severity: SeverityKey = 'success') =>
	createSnackbar({
		message,
		severity,
	})
